import { ListGroup, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { BackendStatusData } from 'src/models/GalenData/BackendStatus.model';
import { I18NextNS } from 'src/models/Language.model';
import { ModelEnum } from 'src/models/Model.model';
import { Session } from 'src/models/Session.model';

import GlobalStack from './GlobalStack';
import ModelStack from './ModelStack';

const modelToBackendStatusObject: Record<
  ModelEnum,
  keyof Omit<BackendStatusData, 'GlobalStatus' | 'SessionId'>
> = {
  [ModelEnum.GENERAL_QUALITY]: 'GeneralQualityStatus',
};

interface ProgressModalBodyProps {
  session: Session;
  shouldShowDilationRecommendation: boolean;
  shouldShowReachMaxRecommendedAttempts: boolean;
  status: BackendStatusData;
  models: ModelEnum[];
}

const ProgressModalBody = ({
  session,
  shouldShowDilationRecommendation,
  shouldShowReachMaxRecommendedAttempts,
  status,
  models,
}: ProgressModalBodyProps) => {
  const { t } = useTranslation(I18NextNS.PAGES, { keyPrefix: 'newExam' });

  return (
    <Modal.Body className="p-4">
      <ListGroup>
        <ListGroup.Item className="p-4">
          <GlobalStack session={session} status={status} />
        </ListGroup.Item>
        {models.map((model, index) => (
          <ListGroup.Item key={index} className="p-4 ps-5">
            <ModelStack
              name={modelToBackendStatusObject[model]}
              status={status}
            />
          </ListGroup.Item>
        ))}
      </ListGroup>

      {shouldShowDilationRecommendation && (
        <p className="my-2">
          <i>{t('dilationRecommendation')}</i>
        </p>
      )}
      {shouldShowReachMaxRecommendedAttempts && (
        <p className="text-danger my-2">
          <i>{t('reachMaxRecommendedAttempts')}</i>
        </p>
      )}
    </Modal.Body>
  );
};

export default ProgressModalBody;
